module.exports = __webpack_public_path__ + "33e7ee803d915eccc87669f4a00feef8.svg";